<template>
  <div>
    <h2>Reporte de Resultados</h2>
    <p>
      Cuestionario para identificar a los trabajadores que fueron sujetos a Acontecimientos Traumáticos Severos
      <br />
      <b>Guía de Referencia I NOM-035-STPS-2018</b>
    </p>
    <h3>Sección I: Acontecimientos Traumáticos Severos</h3>
    <table>
      <template v-for="(reactive) in questionnaire_">
        <tr :key="reactive.idReactive" v-if="parseInt(reactive.idReactive) <= 6">
          <td style="padding:10px">{{reactive.title}}</td>
          <td>
            <b>{{reactive.answer ? "Sí" : "No"}}</b>
          </td>
        </tr>
      </template>
    </table>
    <br />
    <h3>Sección II: Recuerdos Persistentes sobre el acontecimiento traumatico severo</h3>
    <table v-if="questionnaire_.length > 6">
      <template v-for="(reactive) in questionnaire_">
        <tr :key="reactive.idReactive" v-if="reactive.idReactive >= 7 && reactive.idReactive <= 8">
          <td style="padding:10px">{{reactive.title}}</td>
          <td>
            <b>{{reactive.answer ? "Sí" : "No"}}</b>
          </td>
        </tr>
      </template>
    </table>
    <br />
    <h3>Sección III: Esfuerzo por evitar circunstancias parecidas o asociadas al acontecimiento</h3>
    <table v-if="questionnaire_.length > 6">
      <template v-for="(reactive) in questionnaire_">
        <tr :key="reactive.idReactive" v-if="reactive.idReactive > 8 && reactive.idReactive <= 15">
          <td style="padding:10px">{{reactive.title}}</td>
          <td>
            <b>{{reactive.answer ? "Sí" : "No"}}</b>
          </td>
        </tr>
      </template>
    </table>
    <br />
    <h3>Sección IV: Afectación</h3>
    <table v-if="questionnaire_.length > 6">
      <template v-for="(reactive) in questionnaire_">
        <tr :key="reactive.idReactive" v-if="reactive.idReactive > 15 && reactive.idReactive <= 20">
          <td style="padding:10px">{{reactive.title}}</td>
          <td>
            <b>{{reactive.answer ? "Sí" : "No"}}</b>
          </td>
        </tr>
      </template>
    </table>

    <!-- <pre>
      {{questionnaire}}
    </pre>-->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      questionnaire: [],
      host: process.env.VUE_APP_HOST
    };
  },
  computed: {
    questionnaire_() {
      return this.questionnaire.sort((a, b) => a.idReactive - b.idReactive);
    }
  },
  methods: {
    getQuestionnaire() {
      var vm = this;
      let data = {
        idParticipant: this.$route.params.participantId
      };

      axios
        .post(this.host + "/questionnaire/read.php", this.createFormData(data))
        .then(response => {
          vm.questionnaire = response.data.questionnaire;
        })
        .catch(error => {
          this.snackbar = true;
          this.message = "error";
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  created() {
    this.getQuestionnaire();
  }
};
</script>

<style>
</style>